import React from 'react';
import s from './InfoMsg.scss';

export const positions = { CENTER: 0, LEFT: 1, RIGHT: 2 };

const InfoMsg = ({ msg, position = positions.CENTER }) => (
  <div
    className={`${s.infomsg} ${position === positions.RIGHT ? s.right : ''}`}
  >
    <i className={s.icon}>i</i>
    <span>{msg}</span>
  </div>
);

export default InfoMsg;
